import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { ADMIN_PLANS_QUERY_KEY } from './use-get-admin-plans';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

/**
 * Hook to delete a plan
 *
 * DELETE /api/admin/on-prem/plans/{id}
 *
 * Note: Will fail if organizations are assigned to this plan
 */
export const useDeleteAdminPlan = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const deletePlan = async (planId: number) => {
    const url = `api/admin/on-prem/plans/${planId}`;
    const response = await Axios.delete(url);
    return response.data;
  };

  return useMutation<unknown, AxiosError<BaseError>, number>(deletePlan, {
    onSuccess: () => {
      toast.success(t('plan-deleted-successfully'));
      queryClient.invalidateQueries([ADMIN_PLANS_QUERY_KEY]);
    },
    onError: (error: AxiosError<BaseError>) => {
      const errorMessage =
        error.response?.data?.error_description ||
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.response?.data?.message ||
        t('failed-to-delete-plan');
      toast.error(errorMessage);
    }
  });
};
